import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

const posOrderCartWidthAtom = atomWithStorage<number>("posOrderCartWidth", 25);

const usePosOrderCartWidthAtom = () => {
  const atom = useAtom(posOrderCartWidthAtom);
  return atom;
};

export const useSetPosOrderCartWidthAtom = () =>
  useSetAtom(posOrderCartWidthAtom);

export default usePosOrderCartWidthAtom;
